import { useState } from "react";
import styles from "./style.module.css";
import showMore from "../public/icons/chevron_more.svg";
import showLess from "../public/icons/chevron_less.svg";

// current choice summarised on the right, no icon. `name` is
// still the category key (it makes the panel id); `label` is only what is
// printed and defaults to `name`; `summary` is the text on the right half.
export default function Dropdown({
  children,
  name = "Categories",
  label,
  summary,
  startOpen = false,
  open,
  onToggle,
}) {
  // default to open unless caller passes false
  const [innerOpen, setInnerOpen] = useState(startOpen);
  // when the parent passes `open` (a boolean) it owns the state
  // and hears every change through `onToggle`; otherwise the pill keeps
  // its own state as before, and `startOpen` still applies.
  const controlled = typeof open === "boolean";
  const isOpen = controlled ? open : innerOpen;
  const toggle = () => {
    if (controlled) {
      if (typeof onToggle === "function") onToggle(!isOpen);
    } else {
      setInnerOpen((v) => !v);
    }
  };

  // CRA/Vite: svg import is already a URL string (no .src)
  const chevronSrc = isOpen ? showLess : showMore;

  const panelId = `panel-${slugify(name)}`;
  const shownLabel = label == null ? name : label;
  const shownSummary = summary == null ? "" : String(summary);

  return (
    <div className={styles.dropdown_container}>
      {/* use a button so clicks always register and are keyboard accessible */}
      <button
        type="button"
        className={styles.dropdown_header}
        onClick={toggle}
        aria-expanded={isOpen}
        aria-controls={panelId}
      >
        <span className={styles.dropdown_title}>{shownLabel}</span>
        <span className={styles.dropdown_value} title={shownSummary}>
          {shownSummary}
        </span>
        <img src={chevronSrc} className={styles.checkbox_image} alt="" aria-hidden="true" hidden />
      </button>

      <div
        id={panelId}
        className={`${styles.dropdown_items_container} ${isOpen ? styles.open : styles.closed}`}
      >
        {children}
      </div>
    </div>
  );
}

function slugify(s) {
  return String(s).toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]/g, "");
}
